import Api from '../Api';

// Must match ZE360.Api.Features.Me.UserPreferences; the backend rejects unknown keys and values.
export enum UserPreferenceKeys {
    CreateOrderPageVersion = 'create_order_page_version'
}

export type UserPreferences = Partial<Record<UserPreferenceKeys, string>>;

export function fetchUserPreferences(): Promise<UserPreferences> {
    return new Api().get('/me/preferences');
}

export function saveUserPreference(key: UserPreferenceKeys, value: string): Promise<void> {
    return new Api().put(`/me/preferences/${key}`, { value: value });
}
